<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <strong>App User</strong>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol md="8">
            <CForm>
              <CInput
                label="Display Name "
                v-model="user.displayName"
                horizontal
               
                :disabled="mode.viewMode"
                
                
              />
             
              <CInput label="Email" 
               v-model="user.email"   horizontal
                 :disabled="mode.viewMode"
                
                 />   
             
            <CInput label="Mobile Number"
               v-model="user.phoneNumber" horizontal 
                 :disabled="mode.viewMode"/>


              <!-- <CInput label="Notifications"
               v-model="user.notificationSettings.notificationsEnabled" 
               horizontal 
                 :disabled="mode.viewMode"/> -->

   <!-- <div class="form-group row">
						 <label for="example-text-input text-right" class="col-sm-3 col-form-label"> Notifications Enabled</label>
						 <div class="col-sm-9">
						
							<select class="form-control"  v-model="user.notificationSettings.notificationsEnabled" :disabled="mode.viewMode" >
										  <option disabled value="">--Select One Option--</option>
										  <option value="true">Yes</option>
										  <option value="false">No</option>
								 </select>
								 </div>
						   </div> -->
             <!-- <CInput label="Gender"
               v-model="user.gender" horizontal 
                 :disabled="mode.viewMode"/> -->

                 
               
                  <!-- <CInput label="User Address"
               v-model="user.userAddress" horizontal 
                 :disabled="mode.viewMode"/>
             
               <CInput label="Citizen Ship"
               v-model="user.citizenship" horizontal 
                 :disabled="mode.viewMode"/> -->

            </CForm>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter align="right">
         
            <CButton class="mr-2" type="Cancel"  color="danger" @click="cancel()">
             Cancel
            </CButton>
          </CCardFooter>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
 import Vue from "vue";
import {
  required,
  minLength,
  maxLength,
  url,
  requiredIf,
} from "vuelidate/lib/validators";
export default {
  name: "AppUser",
  data() {
    return {
      mode:{
        newMode:false,
        editMode:false,
        viewMode:false,
      },
      uid:"",
      user:{
         uid:"",
        displayName:'',
       phoneNumber:'',
        email:'',
      deleted:'',
        notificationSettings:{
          notificationsEnabled:'',
        },
        // userAddress:'',
        // citizenship:'',
        // userType:'',

      },
      categories:[],
      selected: [],
      show: true,
      roles: [ "ROLE_ADMIN", "ROLE_SUPER ADMIN"],
     
    };
  },

  //  validations: {
  //   user: {
      
  //     name: {
  //          required,
        
  //     },
  //    email: {
  //      required,
  //    },
  //    password: {
  //      required,
  //    },
  //   //   role: {
  //   //    required,
  //   //  },
  //      mobileNumber: {
      
  //    },
  //    gender: {
      
  //    },
  //    country: {
      
  //    },
  //   },
  // },
   created() {  
             
             if(this.$route.params.mode =='view'){
                   this.mode.viewMode=true;
                    this.uid = this.$route.params.uid;
                    this.getCmsUser()
            }
        },
  methods: {
    editMode(){
       this.mode.editMode=true;
        this.mode.viewMode=false;
    },
     cancel() {
      this.$router.push({ name: 'AppUsers' })
    },
   
    getCmsUser() {
      this.apiGetSecure(process.env.VUE_APP_API_HOST +"/web/secure/get/user/"+this.uid)
        .then((response) => response.json())
        .then( (data)  => (this.user = data) );
    },

    // saveCmsUser(){
    //     fetch(process.env.VUE_APP_API_HOST + "/web/secure/save/cmsuser", {
    //       method: "POST",
    //       headers: {
    //         "Content-type": "application/json",
    //       },
    //       body: JSON.stringify(this.user),
    //     }).then((user) => {
    //       console.log(JSON.stringify(user));
    //       this.$router.push({ name: "AppUsers" });
    //     });
    // }
   
   
  },
  mounted() {
    //this.getCmsUser()
  }
};
</script>
